/**
 * @h3eromap/i18n — DE / EN translation strings.
 *
 * The web client (apps/web) loads these via `react-i18next`. The macOS coach
 * app generates `Localizable.strings` from the same source via a script
 * (lands in R1.1 sub-step 4).
 *
 * Hard rule (LOC-089 / CLAUDE.md §12): every user-facing string in the apps
 * must be keyed here. No hardcoded copy in components.
 */
import deStrings from './de.json' with { type: 'json' };
import enStrings from './en.json' with { type: 'json' };

export const de = deStrings;
export const en = enStrings;

/**
 * Canonical locale codes. Date format hint: DE = `DD.MM.YYYY`, EN = `MM/DD/YYYY`.
 * Number format hint: DE = `1.234,56`, EN = `1,234.56`.
 */
export const LOCALES = ['de', 'en'] as const;
export type Locale = (typeof LOCALES)[number];

export const FALLBACK_LOCALE: Locale = 'de';

/**
 * Translation namespace shape — the DE bundle is the canonical source. EN must
 * provide the same keys (validated by `test/parity.test.ts`).
 */
export type Translations = typeof deStrings;

export const resources = {
  de: { translation: deStrings },
  en: { translation: enStrings },
} as const;

export {
  COMMITMENT_AGREEMENT_VERSION,
  COMMITMENT_AGREEMENT_TEXT,
  COMMITMENT_AGREEMENT_DE,
  COMMITMENT_AGREEMENT_EN,
} from './legal/commitment-agreement-v1.js';

export {
  PRIVACY_POLICY_VERSION,
  PRIVACY_POLICY_TEXT,
  PRIVACY_POLICY_DE,
  PRIVACY_POLICY_EN,
} from './legal/privacy-policy-v1.js';

export {
  DPA_VERSION,
  DPA_TEXT,
  DPA_DE,
  DPA_EN,
} from './legal/dpa-v1.js';
